<template>
	<div id="pc">

		<!-- 头部大盒子 -->
		<div class="toperbox ptb15 bw usn">
			<div class="top df dfsb aic w1k2 mauto">

				<div class="topL df aic">
					<!-- logo -->
					<div class="logo"><img class="img" src="../assets/logo.png"></div>
					<div class="topL df ml30" v-if="url != '/index'">
						<el-input placeholder="请输入内容" v-model="sval"></el-input>
						<button class="topSearchBtn" type="button" @click="seacher">搜索</button>
					</div>
				</div>

				<!-- 右面 -->
				<div class="topR df aic">
					<!-- 头部导航 -->
					<div class="topnav">
						<div class="nav c333 f18">
							<ul class="df">
								<li :class="item.to == url ? 'active cp' : 'cp'" v-for="(item,index) in nav"
									:key="index" @click="toLink(item.to)">
									<div>{{item.name}}</div>
									<div class="navLine"></div>
								</li>
							</ul>
						</div>
					</div>
					<!-- 用户 -->
					<!--<div class="topAdmin ml2" v-if="login" @click="clickUserphoto">
						<div class="userphoto oh wh36 br50p cp">
							<el-avatar :src="userphoto"></el-avatar>
						</div>
					</div>-->
          <el-dropdown class="topAdmin ml2" v-if="login" trigger="click">
            <div class="userphoto oh wh36 br50p cp">
              <el-avatar :src="userphoto"></el-avatar>
            </div>
            <el-dropdown-menu slot="dropdown">
              <!-- <router-link to="/user/profile">
                <el-dropdown-item>个人中心</el-dropdown-item>
              </router-link>
              <el-dropdown-item @click.native="setting = true">
                <span>布局设置</span>
              </el-dropdown-item> -->
              <el-dropdown-item @click.native="clickUserphoto">
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
					<p class="cp c333" v-else @click="clickHeadLogin">登录</p>
				</div>

			</div>
		</div>



		<!-- 登录弹窗 -->
		<div class="window usn" v-if="loginAlert">
			<!-- 登录弹窗 -->
			<div class="loginAlert oh pa pmid df bw">
				<!-- 登录弹窗左 -->
				<div class="loginAlertL df aic">
					<div class="loginAlertLBox df dfc aic w100p">
						<!-- 白色logo -->
						<div class="loginAlertLImg">
							<img src="../assets/whiteLogo.png">
						</div>
						<!-- 文字 -->
						<div class="loginAlertLTxt mt30 cw">
							<p>如需体验全部功能或升级VIP</p>
							<p class="mt20">请扫描下方二维码联系我们</p>
						</div>
						<!-- logoQr -->
						<div class="loginAlertLQr mt30">
							<img src="../assets/logoQr.png">
						</div>
					</div>
				</div>
				<!-- 登录弹窗右 -->
				<div class="loginAlertR pr f1 pt30 pl40">
					<!-- 关闭icon -->
					<div class="loginAlertClose pa r0 wh20 mr20 cp" @click="loginAlertClose"><img
							src="../assets/icon-close.png"></div>
					<!-- 选择标题 -->
					<div class="loginAlertRList df dfl mt20 f22 b">
						<div :class="(ti == 1)? 'loginAlertRTitle active':'loginAlertRTitle'"
							@click="ti = 1,forget = false">
							<p class="cp">登录</p>
							<div class="underline"></div>
						</div>
						<div :class="(ti == 2)? 'loginAlertRTitle active ml50':'loginAlertRTitle ml50'" @click="unopen">
							<p class="cp">游客登录</p>
							<div class="underline"></div>
						</div>
						<!-- <div :class="(ti == 2)? 'loginAlertRTitle active ml50':'loginAlertRTitle ml50'" @click="ti = 2"><p class="cp">游客登录</p><div class="underline"></div></div> -->
					</div>
					<!-- 账号 -->
					<div class="loginAlertRList mt30" v-if="ti == 1">
						<p class="c999 f18 pb15">账号</p>
						<el-input class="w400" v-model="number" placeholder="请输入账号"></el-input>
					</div>
					<!-- 手机号 -->
					<div class="loginAlertRList mt30" v-if="ti == 2">
						<p class="c999 f18 pb15">手机号</p>
						<el-input class="w400" type="text" onkeydown="value = value.replace(/[^0-9]/g,'')"
							v-model="mobile" placeholder="请输入手机号"></el-input>
					</div>
					<!-- 密码 -->
					<div class="loginAlertRList mt30" v-if="ti == 1">
						<p class="c999 f18 pb15">密码</p>
						<div class="loginAlertRPwd pr">
							<el-input v-model="password" placeholder="请输入密码" show-password></el-input>
						</div>
					</div>
					<!-- 验证码 -->
					<div class="loginAlertRList mt30" v-if="ti == 2">
						<p class="c999 f18 pb15">验证码</p>
						<div class="loginAlertRPwd pr">
							<el-input v-model="code" placeholder="请输入验证码"></el-input>
							<div class="getCode pa t0 pr20 lh40 c5775EF usn cp" @click="getCode">{{codeVal}}</div>
						</div>
					</div>
					<div class="loginAlertRList df dfsb h20 mt25 f16">
						<div class="loginAlertRListL cFF4254" v-if="ti == 1"><span v-if="forget">忘记密码请联系我们</span></div>
						<div class="loginAlertRListR c999 cp" v-if="ti == 1"><span @click="showForget">忘记用户名或密码</span>
						</div>
					</div>
					<!-- 注册 -->
          <Vcode :show="codeBox" @success="onSuccess" @close="close" />
					<div class="loginAlertRList mt20 ptb15 tac cw b5775ef br5 cp" v-if="ti == 1" @click="toLogin">登录
					</div>
					<div class="loginAlertRList mt20 ptb15 tac cw b5775ef br5 cp" v-if="ti == 2" @click="register">登录
					</div>
				</div>
			</div>
		</div>


	</div>
</template>



<script>

  import Vcode from "vue-puzzle-vcode";
	export default {
		// 页面变量
		data() {
			return {
				// 关键字
				sval: '',

				// 用户头像
				userphoto: require("../assets/userphoto.png"),

				// 导航
				nav: [{
						name: "HCO查询",
						to: "/index",
					},
					{
						name: "HCO匹配",
						to: "/hoc",
					},
					{
						name: "API",
						to: "/api",
					},
					{
						name: "个人中心",
						to: "/mineinfo",
					},
				],
				// 路径
				url: "",

				// 账号
				number: '',

				// 手机号
				mobile: '',
				// 密码
				password: '',
				// 验证码
				code: '',
				// 标题
				ti: 1,
				// 忘记密码提示
				forget: false,
				// 登录弹窗
				loginAlert: false,
				// 改变登录
				changeLogin: false,
				// 验证码值
				codeVal: '获取验证码',
				// 跳转路径
				goLink: '',
				// 是否登录
				login: false,
				// 验证码盒子
				codeBox: false,
				// 滑块底纹文字
				text: '滑动进行验证',
				// 验证key
				key: '',
			}
		},

    components: {
      Vcode
    },
		// 实例化后
		created() {

			//
			var that = this;

			// 改变样式
			that.changeStyle();

			//
			if(localStorage.getItem("token")){
				that.login = true;
			}else{
				that.login = false;
			}

		},


		watch:{

			//	监听账号变化
			number(val){

				// var that = this;

				// that.$set(this,"number",val);

				// that = Object.assign({},that)

			},

			//
			mobile(){

			},



		},


		// 页面激活时
		activated(){

			var that = this;

			setTimeout(function(){

				// 改变样式
				that.changeStyle();

				//
				if(localStorage.getItem("token")){
					that.login = true;
				}else{
					that.login = false;
				}

			},500)

		},


		// 方法集
		methods: {

      loginAlertClose(){
        this.loginAlert = false
        this.number = null
        this.mobile = null
        this.password = null
        this.code = null
      },
			// 清空本地文本框内容
			clearInput(){

				var that = this;

				// 账号
				that.number = '';
				// 手机号
				that.mobile = '';
				// 密码
				that.password = '';
				// 验证码
				that.code = '';
			},

      close() {
        this.codeBox = false;
      },

			// 注册
			register() {

				var that = this;

				// 判断手机号是否为空
				if (!that.mobile) {
					// 弹窗提示
					that.$message.warning('请填写手机号');
					return;
				};

				// 判断验证key是否为空
				if (!that.key) {
					// 弹窗提示
					that.$message.warning('请获取新的验证码，不要关闭页面');
					return;
				};

				// 判断验证码是否为空
				if (!that.code) {
					// 弹窗提示
					that.$message.warning('请填写验证码');
					return;
				};

				// 请求接口 注册
				that.request({
					url: '/api/member/signIn',
					// 上传数据
					data: {
						// 手机号
						tel: that.mobile,
						// 验证key
						smskey: that.key,
						// 验证码
						code: that.code,
					},
					// 调用成功
					success(rs) {
						// 返回成功
						if (rs.code == 200) {

							// 关闭登录弹窗
							that.loginAlert = false;

							// 弹窗提示
							that.$message.success('恭喜，登录成功');

							// 变换缓存
							that.changeLocalStorage(rs);

							// 刷新页面
							location.reload();

							// 跳转首页
							that.$route.push('/');

							// 登录状态
							that.login = true;

							// 清空输入框
							that.clearInput();

							// 半秒后执行
							setTimeout(() => {
								// 关闭弹窗
								that.loginAlert = false;
							}, 500);

							// 跳转登录
							if(that.goLink){
								that.$router.replace(that.goLink);
							}


						} else {

							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})

			},

			// 退出登录
			backLogin() {

				var that = this;

				// 登录状态
				that.login = false;

				// 退出登录
				that.loginAlert = false;

				// 清空缓存
				that.changeLocalStorage();

				// 改变登录弹窗
				that.changeLogin = false;

				// 跳转登录
				that.$route.path == "/index" ? location.reload() : that.$router.replace("/index");

			},


			// 滑块验证码执行成功调用函数
			onSuccess() {
				var that = this;

				// 关闭滑块验证码弹窗
				that.codeBox = false;

				// 请求接口 会员接口
				that.request({
					url: '/api/member/login',
					// 上传数据
					data: {
						// 用户名
						name: that.number,
						// 密码
						password: that.password,
					},
					// 调用成功
					success(rs) {
						// 返回成功
						if (rs.code == 200) {

							// 关闭登录弹窗
							that.loginAlert = false;

							// 保存缓存
							that.changeLocalStorage(rs);


							location.reload();

							// // 弹窗提示
							// that.alert({
							// 	value:"登录成功",
							// 	success(){
							// 		location.reload();
							// 	}
							// })

							// 弹窗提示
							that.$message.success('登录成功');

							// 跳转登录
							if(that.goLink){
								that.$router.replace(that.goLink);
							}

						} else {
							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})
			},

			// 搜索
			seacher() {
				var that = this;

				// 判断输入框是否有值
				if (!that.sval) {
					that.$message.warning('请输入内容');
					return;
				};

				// 跳转页面
				that.$router.push({
					path: '/seacherDetails',
					query: {
						// 传值
						value: that.sval,
					}
				});
			},

			// 改变样式
			changeStyle() {

				var that = this;

				// 判断条件更改样式
				if (that.$route.path == '/seacherDetails') {
					// 赋值首页
					that.url = '/index';
				} else if (that.$route.path == '/details') {
					// 赋值首页
					that.url = '/index';
				} else if (that.$route.path == '/minerepwd') {
					// 赋值个人中心
					that.url = '/mineinfo';
				} else if (that.$route.path == '/minekey') {

					// 赋值个人中心
					that.url = '/mineinfo';

				}else {

					// 赋值
					that.url = that.$route.path;

				}

			},

			// 跳转
			toLink(url) {

				var that = this;

				// 判断是否有token
				if(!localStorage.getItem('token')){


					that.$router.push('/');

					// 弹窗提示用户
					that.$message.warning('您还未登录，请先登录');

					// 打开登录弹窗
					that.loginAlert = true;

					// 跳转登录信息
					that.goLink = url;

					return ;
				};

				// 跳转页面
				that.$router.push(url);

			},

			// 登录
			toLogin() {

				var that = this;

				// 判断用户名是否为空
				if (!that.number) {
					that.$message.warning('请输入账号')
					return;
				};

				// 判断密码是否为空
				if (!that.password) {
					that.$message('请输入密码');
					return;
				};

				// 打开登录验证码
				this.codeBox = true;


			},

			// 显示忘记密码
			showForget() {
				// 显示忘记密码
				this.forget = true;
			},

			// 获取验证码
			getCode() {

				var that = this;

				// 判断手机号是否为空
				if (!that.mobile) {
					that.$message.warning('请输入手机号');
					return;
				};

				// 判断值是否获取验证码
				if (that.codeVal != '获取验证码') {
					return;
				};

				// 请求接口 发送验证码
				that.request({
					url: '/api/member/sendSms',
					// 上传数据
					data: {
						// 手机号
						phoneNumber: that.mobile,
					},
					// 调用成功
					success(rs) {
						// 返回成功
						if (rs.code == 200) {
							//弹窗提示用户
							that.$message.success('短信已发送，请稍等片刻');

							// 保存验证key
							that.key = rs.data;

							// 设置 倒计时时间 秒
							var countTime = 120;
							that.codeVal = countTime + '秒后获取';
							// 倒计时
							var codeTime = setInterval(() => {
								// 判断字是否是 获取验证码
								if (countTime > 0) {
									// 减1
									countTime--;
									// 赋值时间
									that.codeVal = countTime + '秒后获取';
								} else {
									// 赋值汉字
									that.codeVal = '获取验证码';
									// 清除定时器
									clearInterval(codeTime);
								};
							}, 1000)
						} else {
							//弹窗提示用户
							that.$message.error(rs.msg);
						};
					}
				})
			},

			// 点击头像
			clickUserphoto() {
				var that = this;
				that.alert({
					value:"要退出登录吗？",
					success(rs){
						if(rs.confirm){
							that.backLogin();
						}
					}
				})
			},

			// 弹窗提示
			unopen() {
				var that = this;
				// 切换标题下标
				that.ti = 2;
				// 关闭忘记
				that.forget = false
			},

			// 点击头部登录
			clickHeadLogin(){
				var that = this;
				if(that.$route.path == "/index"){
					that.loginAlert = true;
				}else{
					that.$route.replace("/index");
				}

			},

			// 清空各种缓存
			changeLocalStorage(e){

				// 判断是否有传参
				if(e) {

					// 缓存token
					localStorage.setItem('token', e.data.token);
					// 用户id
					localStorage.setItem('memberId', e.data.memberId);
					// 用户名称
					localStorage.setItem('memberName', e.data.memberName);
					// 缓存用户身份
					localStorage.setItem('memberLevelId', e.data.memberLevelId);
					// 等级
					localStorage.setItem('memberLevelName', e.data.memberLevelName);
					// 注册时间
					localStorage.setItem('createTime', e.data.createTime);

				} else {

					// 缓存token
					localStorage.removeItem('token');
					// 用户id
					localStorage.removeItem('memberId');
					// 用户名称
					localStorage.removeItem('memberName');
					// 缓存用户身份
					localStorage.removeItem('memberLevelId');
					// 等级
					localStorage.removeItem('memberLevelName');
					// 注册时间
					localStorage.removeItem('createTime');

				}

			},
		},
	};
</script>
<style>

	.topL .el-input .el-input__inner {
		width: 100%;
		border-color: #AACFFF;
	}

	/* 顶部搜索按钮 */
	.topSearchBtn {
		width: 120px;
		height: 40px;
		color: white;
		background-color: #0060DD;
		border: 0;
		border-radius: 0 4px 4px 0;
	}

	/* logo */
	.logo {
		width: 175px;
		height: 52px;
	}

	/* 头部导航 */
	.topnav .nav ul li {
		position: relative;
		margin-left: 30px;
		margin-right: 30px;
		padding: 10px 0;
		border-bottom: #FFF;
	}

	.topnav .nav ul li a div {
		color: #333;
	}

	/* 导航下线 */
	.navLine {
		position: absolute;
		bottom: -5px;
		width: 0%;
		height: 6px;
		background-color: #0066dd;
		border-radius: 5px;
		transition: .3s;
	}

	/* 导航选中 */
	.topnav .nav ul li.active {
		color: #0066dd;
		font-weight: bold;
	}

	/* 导航选中下线 */
	.topnav .nav ul li.active .navLine {
		width: 100%;
	}

	.toperbox .el-input__inner {
		width: 300px;
	}

	/* 搜索按钮 */
	.toperbox .el-input-group__append {
		width: 60px;
		text-align: center;
		letter-spacing: 2px;
		color: white;
		background-color: #0060dd;
		border-color: #0060dd;
	}


	/* 登录弹窗 */
	.loginAlert {
		width: 950px;
		height: 480px;
		border-radius: 24px;
	}

	/* 登录弹窗左 */
	.loginAlertL {
		width: 387px;
		background: linear-gradient(160deg, #5775EF 0%, #78A1F5 100%);
	}

	/* 白色logo */
	.loginAlertLImg {
		width: 204px;
		height: 61px;
	}

	/* logoQr */
	.loginAlertLQr {
		/* width: 130px; */
		/* height: 116px; */
	}

	/* logoQr */
	.loginAlertLQr img {
		width: 130px;
	}

	/* 登录右边列表 */
	.loginAlertRList {
		width: 400px;
	}

	/* 登录右边标题 */
	.loginAlertRTitle {
		color: #999;
		transition: .2s;
	}

	/* 登录右边标题选中 */
	.loginAlertRTitle.active {
		color: #333;
	}

	/* 登录右边标题鼠标滑过 */
	.loginAlertRTitle:hover {
		color: #333;
	}

	/* 下划线 */
	.underline {
		width: 48px;
		height: 5px;
		margin: 15px auto 0;
		background: #5775EF;
		border-radius: 100px;
		opacity: 0;
		transition: .2s;
	}

	/* 登录右边标题选中下划线 */
	.loginAlertRTitle.active .underline {
		opacity: 1;
	}

	/* 高20 */
	.h20 {
		height: 20px;
	}

	/* 获取验证码 */
	.getCode {
		right: 30px;
	}

	/* 滑块验证码的盒子 */
	.bigCodeBox {
		padding: 20px;
		background: #fff;
		border-radius: 5px;
		box-shadow: 0 0 10px #00000055;
		z-index: 99;
	}

	/* 滑块验证码 */
	.slide-verify-slider {
		margin-top: -3px;
		border: 0;
	}
</style>
